<template>
    <div>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    v-bind    = "attrs"
                    v-on      = "on"
                    :color    = "buttonColor"
                    :disabled = "disabled"
                    class     = "mb-3"
                    @click    = "onClick"
                    small
                >
                    <v-icon :class = "iconColor">{{ icon }}</v-icon>
                </v-btn>
            </template>
            <span>{{ $t( label ) }}</span>
        </v-tooltip>
    </div>
</template>

<script>

export default {
    name: "CMenuButton",

    components: {
    },

    props: {
        label: {
            required: true,
            type    : String
        },
        disabled: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },
        icon: {
            required: true,
            type    : String
        },
        buttonColor: {
            required: false,
            type    : String,
            default : function () {
                return "white";
            }
        },
        iconColor: {
            required: false,
            type    : String,
            default : function () {
                return null;
            }
        }
    },

    data: () => ({
    }),

    methods: {
        onClick () {
            this.$emit("click")
        },
    }
}
</script>

<style scoped>

::v-deep .theme--light.v-btn.v-btn--disabled {
    border-color: lightgrey;
    border-width: 1px;
    border-style: solid;
    box-shadow: none;
}

</style>